import React, { Component } from 'react';
import { StarIcon } from 'lucide-react';
import { ComboComponents } from './ComboComponents';
import { PaymentOptions } from './PaymentOptions';
import { LoyaltyPoints } from './LoyaltyPoints';
import { FreeGiftBanner } from './FreeGiftBanner';
import { GlobalBadge } from '../shared/GlobalBadge';
interface ProductInfoProps {
  product: {
    name: string;
    brand: string;
    sku: string;
    price: number;
    originalPrice?: number;
    discount?: number;
    rating: number;
    reviewCount: number;
    inStock: boolean;
    stockStatus: string;
    tags?: string[];
    loyaltyPoints?: number;
    isGlobal?: boolean;
  };
  hideComboComponents?: boolean;
  hidePaymentOptions?: boolean;
}
export function ProductInfo({
  product,
  hideComboComponents = false,
  hidePaymentOptions = false
}: ProductInfoProps) {
  return <div className="space-y-6" data-id="element-5279" data-mp="18dgbdtiiecqc">
      {/* Main Product Info Card */}
      <div className="rounded-xl border border-gray-200 bg-white shadow-sm p-4 md:p-5" data-id="element-5280" data-mp="1dc9ecs066lc9">
        {/* Brand */}
        <div className="flex items-center flex-wrap gap-2 mb-2" data-id="element-5281" data-mp="31shy03zjvmpq">
          <span className="text-sm font-semibold text-gray-900 uppercase tracking-wide" data-id="element-5282" data-mp="2wuq6vc6qc4ml">
            {product.brand}
          </span>
          <a href="#" className="text-xs text-[#1E2B55] hover:underline" data-id="element-5283" data-mp="3at7rh11c910a">
            View More
          </a>
        </div>
        {/* Product Name */}
        <h1 className="text-xl md:text-2xl font-semibold text-gray-900 mb-3 leading-tight" data-id="element-5284" data-mp="36qt4c4qmzf37">
          {product.name}
        </h1>
        {/* Price */}
        <div className="mb-4" data-id="element-5285" data-mp="2e59sbky7mbn6">
          <div className="flex items-baseline gap-3 mb-2" data-id="element-5286" data-mp="2e1vqqexde6gs">
            <span className="text-3xl font-bold text-red-600" data-id="element-5287" data-mp="2rwev2vwvjk1q">
              SAR {product.price.toFixed(2)}
            </span>
            {product.originalPrice && <span className="text-lg text-gray-400 line-through" data-id="element-5288" data-mp="1zeu8a9hj59ql">
                SAR {product.originalPrice.toFixed(2)}
              </span>}
          </div>
          {product.discount && product.discount > 0 && <div className="inline-block bg-red-100 text-red-700 text-sm font-bold px-3 py-1 rounded-full" data-id="element-5289" data-mp="3uh7f203ldov1">
              Save {product.discount}%
            </div>}
        </div>
        {/* Rating & Reviews */}
        <div className="flex items-center gap-2 mb-3" data-id="element-5290" data-mp="83fv3awha1d9">
          <div className="flex items-center gap-0.5" data-id="element-5291" data-mp="d2aae2v8l7sm">
            {[...Array(5)].map((_, i) => <StarIcon key={i} className={`w-3.5 h-3.5 ${i < Math.floor(product.rating) ? 'text-yellow-400 fill-yellow-400' : 'text-gray-300'}`} data-id="element-5292" data-mp="3bjwgyitp51h6" data-mpi={i} />)}
          </div>
          <span className="text-sm font-bold text-gray-900" data-id="element-5293" data-mp="3lgrbyrqrgjqp">
            {product.rating}
          </span>
          <span className="text-xs text-gray-500" data-id="element-5294" data-mp="3qi8awhpopw4n">
            ({product.reviewCount} reviews)
          </span>
          <div className="ml-auto" data-id="element-5295" data-mp="10r1xwgxvt1z2">
            <GlobalBadge size="md" data-id="element-5296" data-mp="15q65x492ktnt" />
          </div>
        </div>
        {/* SKU & Stock */}
        <div className="flex items-center gap-4 mb-4 text-sm" data-id="element-5297" data-mp="2q8gyfnggfw26">
          <div className="flex items-center gap-2" data-id="element-5298" data-mp="2q7npqgxxqwhe">
            <span className="text-gray-500" data-id="element-5299" data-mp="2l8uc8oinf5h8">SKU:</span>
            <span className="font-medium" data-id="element-5300" data-mp="2lbgtxgz971d6">{product.sku}</span>
          </div>
          <div className={`font-medium ${product.inStock ? 'text-green-600' : 'text-red-600'}`} data-id="element-5301" data-mp="2ghcioliyg76a">
            {product.stockStatus}
          </div>
        </div>
        {/* Tags */}
        {product.tags && product.tags.length > 0 && <div className="flex flex-wrap gap-2 mb-4" data-id="element-5302" data-mp="22j4k6969sxt0">
            {product.tags.map((tag, index) => <span key={index} className="inline-flex items-center gap-1 bg-blue-50 text-blue-700 text-xs font-medium px-3 py-1 rounded-full" data-id="element-5303" data-mp="1xj9rq16uk05u" data-mpi={index}>
                {tag}
              </span>)}
          </div>}
        {/* Free Gift Banner */}
        <FreeGiftBanner data-id="element-5304" data-mp="3myg7dj0iowla" />
        {/* Loyalty Points */}
        {product.loyaltyPoints && <div className="border-t border-gray-200 pt-4 mt-4" data-id="element-5305" data-mp="2kks6bcn66r59">
            <LoyaltyPoints points={product.loyaltyPoints} data-id="element-5306" data-mp="2kjh0z8e2tbc1" />
          </div>}
      </div>
      {/* Combo Components */}
      {!hideComboComponents && <ComboComponents data-id="element-5307" data-mp="2am2lbazz8qks" />}
      {/* Payment Options */}
      {!hidePaymentOptions && <PaymentOptions price={product.price} data-id="element-5308" data-mp="2flp7i9xs9h5q" />}
    </div>;
}